import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 查找客服关爱记录
export function queryendphonecalllist (params, data) {
  params.token = getToken()
  return request({
    url: '/queryendphonecalllist',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/callphone.js